import axios from 'axios';

import axiosInstance from './axiosCreator';

export const getProfilePictureUploadUrl = async (
  bucket: string,
  dirName: string,
  filename: string
): Promise<{ url: string | null }> => {
  try {
    const response = await axiosInstance.get(
      `/aws/profile-picture/upload-url?bucket=${bucket}&dir_name=${dirName}&filename=${filename}`
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching presigned URL:', error);
    return { url: null };
  }
};

export const getSchoolPictureUploadUrl = async (
  bucket: string,
  dirName: string,
  filename: string
): Promise<{ url: string | null }> => {
  try {
    const response = await axiosInstance.get(
      `/aws/school-picture/upload-url?bucket=${bucket}&dir_name=${dirName}&filename=${filename}`
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching presigned URL:', error);
    return { url: null };
  }
};

interface LectureUploadRequestBody {
  originalFilename: string;
  contentType: string;
  fileSize?: number;
}

interface LectureUploadUrlResponse {
  uploadUrl: string;
  key: string;
  max_size_bytes: number;
  max_size_mb: number;
}

/**
 * Requests a presigned URL from the backend to upload a lecture file directly to S3.
 */
export const getLectureUploadUrl = async (
  data: LectureUploadRequestBody
): Promise<LectureUploadUrlResponse> => {
  try {
    const response = await axiosInstance.post<LectureUploadUrlResponse>(
      '/aws/lectures/upload-url',
      data
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching lecture upload URL:', error);
    return {
      uploadUrl: '',
      key: '',
      max_size_bytes: 0,
      max_size_mb: 0,
    };
  }
};

interface ChatAttachmentUploadRequestBody {
  mimeType: string;
  sizeBytes: number;
}

interface ChatAttachmentUploadUrlResponse {
  uploadUrl: string;
  key: string;
}

export const getChatAttachmentUploadUrl = async (
  body: ChatAttachmentUploadRequestBody
): Promise<ChatAttachmentUploadUrlResponse | null> => {
  try {
    const response = await axiosInstance.post<ChatAttachmentUploadUrlResponse>(
      '/aws/chat-attachments/upload-url',
      body
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching chat attachment upload URL:', error);
    return null;
  }
};

export const uploadChatAttachmentToS3 = async (
  uploadUrl: string,
  blob: Blob,
  mimeType: string
): Promise<void> => {
  await axios.put(uploadUrl, blob, {
    headers: { 'Content-Type': mimeType },
  });
};
